import ContactArea from "@/components/publicWebsite/contact/contactArea";
import ContactInfoArea from "@/components/publicWebsite/contact/contactInfoArea";
import PageHeader from "@/components/publicWebsite/common/pageHeader";

export default function Contact() {  
  return (
    <>
      <PageHeader title="Contact" image="/images/banners/c19.jpg"/>
      <div className="pb-120 border-bottom"></div>
      <ContactInfoArea />
      <ContactArea />
    
    </>
  );
};
 
